import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface Company {
  id: string
  name: string
  // Add other company properties as needed
}

interface CompanyState {
  selectedCompany: Company | null
  companies: Company[]
  setSelectedCompany: (company: Company | null) => void
  setCompanies: (companies: Company[]) => void
  addCompany: (company: Company) => void
  removeCompany: (companyId: string) => void
}

export const useCompanyStore = create<CompanyState>()(
  persist(
    (set, get) => ({
      selectedCompany: null,
      companies: [],

      setSelectedCompany: (company) => set({ selectedCompany: company }),

      setCompanies: (companies) => set({ companies }),

      addCompany: (company) => set((state) => ({
        companies: [...state.companies, company]
      })),

      removeCompany: (companyId) => set((state) => ({
        companies: state.companies.filter(company => company.id !== companyId),
        selectedCompany: state.selectedCompany?.id === companyId ? null : state.selectedCompany
      })),
    }),
    {
      name: 'company-storage',
      partialize: (state) => ({
        selectedCompany: state.selectedCompany,
        companies: state.companies,
      }),
    }
  )
)
